import { render, staticRenderFns } from "./aShopData.vue?vue&type=template&id=421a8f3a&scoped=true"
import script from "./aShopData.vue?vue&type=script&lang=js"
export * from "./aShopData.vue?vue&type=script&lang=js"
import style0 from "./aShopData.vue?vue&type=style&index=0&id=421a8f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a8f3a",
  null
  
)

export default component.exports